import { useCurrentUser } from '@mp/hooks';
import { useGetWorkExperienceInitialData } from '../useGetWorkExperienceInitialData';
import { validateExperience, ValidationResult } from './validateExperience';

type UseValidationProps = {
  startDate?: Date;
  endDate?: Date;
  currentlyWorkHere?: boolean;
};

export const useExperienceValidationFromContext = ({
  startDate,
  endDate,
  currentlyWorkHere,
}: UseValidationProps = {}): ValidationResult => {
  const { currentUser } = useCurrentUser();
  const { workHistories } = useGetWorkExperienceInitialData();

  return validateExperience(workHistories ?? [], currentUser, {
    startDate,
    endDate,
    currentlyWorkHere,
  });
};
